export default "__VITE_ASSET__0e996b90__"